import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { HeaderComponent } from './header/header.component';

@Component({
  selector: 'app-includes',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./includes.component.css']
})
export class IncludesComponent implements OnInit {

  constructor(private auth: AuthService) {
  }

  ngOnInit() { }

}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/includes/includes.component.ts